import { isKeyframeEasing, type KeyframeEasing } from '../../../../../../../protocol/keyframe-easing';
export { KEYFRAME_EASINGS, isKeyframeEasing, type KeyframeEasing } from '../../../../../../../protocol/keyframe-easing';

/** Outgoing interpolation: this keyframe through the next keyframe, never a preset effect. */
export type EasedKeyframe = { frame: number; easing?: KeyframeEasing };

/** Missing means legacy linear. Invalid explicit values fail rather than silently changing motion. */
export const keyframeProgress = (progress: number, easing?: KeyframeEasing): number => {
  if (easing !== undefined && !isKeyframeEasing(easing)) {
    throw new Error('Invalid keyframe easing');
  }
  const t = Math.min(1, Math.max(0, progress));
  switch (easing) {
    case 'ease-in': return t * t;
    case 'ease-out': return 1 - (1 - t) * (1 - t);
    case 'ease-in-out': return t < 0.5 ? 2 * t * t : 1 - 2 * (1 - t) * (1 - t);
    case 'hold': return t < 1 ? 0 : 1;
    default: return t;
  }
};

/** Last keys have no outgoing interval. Unchanged selections must not create an Undo entry. */
export const setKeyframeEasing = <T extends EasedKeyframe>(
  keyframes: T[], frame: number, easing: KeyframeEasing,
): T[] => {
  if (!isKeyframeEasing(easing)) throw new Error('Invalid keyframe easing');
  const target = Math.round(frame);
  const point = keyframes.find((entry) => Math.round(entry.frame) === target);
  if (!point || !keyframes.some((entry) => entry.frame > point.frame) ||
      (point.easing ?? 'linear') === easing) return keyframes;
  return keyframes.map((entry) => entry === point ? { ...entry, easing } : entry);
};
